import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { IRecipient } from '@common/recipient';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { getRecipientSchema } from '@common/validation/utils/getRecipientSchema';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';

export type IBariPreDietPlanAppointmentData = {
    // This should be mandatory, but is currently optional for backwards compatibility CS-17827
    recipient?: IRecipient;
    toelichting: string | null;
};

export type BariPreDietPlanAppointmentReadKey = keyof IBariPreDietPlanAppointmentData;
export type BariPreDietPlanAppointmentReadLabel = 'Toelichting' | 'Versturen naar';

export const bariPreDietPlanAppointmentReadSchema: TypedReadSchema<
    BariPreDietPlanAppointmentReadKey,
    BariPreDietPlanAppointmentReadLabel
>[] = [
    {
        items: [
            { key: 'recipient', label: 'Versturen naar' },
            { key: 'toelichting', label: 'Toelichting' },
        ],
    },
];

const bariPreDietPlanAppointmentFinal: TypedSchema<IBariPreDietPlanAppointmentData> = {
    recipient: getRecipientSchema(),
    toelichting: getTextAreaStringSchema().allow(null),
};

const bariPreDietPlanAppointmentDraft: TypedSchema<IBariPreDietPlanAppointmentData> = {
    recipient: getRecipientSchema(true, true),
    toelichting: getTextAreaStringSchema().allow(null),
};

export const bariPreDietPlanAppointmentDraftSchema = Koi.object(bariPreDietPlanAppointmentDraft);
export const bariPreDietPlanAppointmentFinalSchema = Koi.object(bariPreDietPlanAppointmentFinal);
